<div class="registaration">
    <div class="r-header">
        <img src="assets/images/logo-dark.svg" alt="">
    </div>
    <div class="sidebar">
        <img src="assets/images/logo.svg" class="logo" alt="">
        <h2>
            Unfortunately, we couldn’t complete your payment. Please check your details and try again. If the issue
            persists, contact our support team.
        </h2>
        <img src="assets/images/r-sidebar-v.svg" class="r-sidebar-v animated" alt="">
    </div>
    <div class="form-body">
        <div class="successfully-payment">
            <img src="assets/images/cross.png" class="check animated-zoom" alt="">
            <h3 class="title">
                Payment Unsuccessful
            </h3>
            <button class="btn btn-primary-outline btn-md w-100" (click)="goToBilling()">
                Back to Billing
            </button>
            <button class="btn btn-primary btn-md w-100" (click)="goToHomepage()">
                Home
            </button>
        </div>
    </div>
</div>